<style scoped>

</style>

<template>
  <component style="text-align: center" :is="componentName" :orderId="id" :payMethod="this.apply.payMethod" :applyResult="apply.result" />
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import FormPay from './FormPay'
import ScanPay from './ScanPay'
const { mapState } = createNamespacedHelpers('payApply')

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  components: {
    FormPay,
    ScanPay,
  },
  computed: {
    ...mapState([
      'apply'
    ]),
    componentName() {
      let name
      switch (this.apply.payMethod) {
        case 'wechat-scan':
          name = 'ScanPay'
          break
        case 'alipay-web':
          name = 'FormPay'
          break
        default:
          name = 'span'
      }
      return name
    }
  },
  methods: {
    payApply(id) {
      this.$store.dispatch('payApply/apply', id)
    }
  },
  mounted() {
    this.payApply(this.id)
  }
}
</script>
